<template>
    <div class="Controls">
        <span @click="toOther(value.value)" style="color:#008cee">{{value.value}}</span>
    </div>
</template>

<script>
export default {
    name: 'Controls',
    props: {
        value: {
            type: Object,
            default: function () {
                return {
                    value: ''
                }
            }
        }
    },
    data() {
        return {
        }
    },
    created() {
    },
    methods: {
        toOther(value) {
            if (value && value != '') {
                if (value.indexOf('http://') != -1 || value.indexOf('https://') != -1) {
                    window.open(value)
                } else {
                    window.open('https://' + value)
                }
            }
        }
    },
    watch: {
    },
    components: {
    }
}
</script>
